import { ChangeEvent, useEffect } from "react";
import { ReactNode, useState } from "react";
import { createContext } from "react";
import { useHistory } from "react-router-dom";
import { getTaxValueInDTO } from "..";
import { PersonEntity } from "..";
import { toastError } from "../../../../../components/Toast";
import useAppData from "../../../../../hook/useAppData";
import { convertDate, currentDate, splitFormartDate } from "../../../../../libs/dateUtils";
import { orderByName } from "../../../../../libs/orderList";
import { ACCESS } from "../../../../Profile/constants";
import { getTaxes } from "../../../../Taxes/service";
import { ProfileProps, StoreContextProps, ValuesInterface } from "../../../model";
import { serviceUsers } from "../../../service";
import { gerateDinamicObjectCollaborator, objectGenerator } from "../professional-data/libs";

interface StoreProviderProps {
  children: ReactNode;
  params: any;
}

const initialValues: ValuesInterface = {
  name: "",
  email: "",
  hourBase: 0,
  CPF: "",
  RG: "",
  phone: "",
  phone_two: "",
  isDeleted: false,
  profile: undefined,
  birth_date: "",
  contract_type: "PJ",
  email_personal: "",
  pay_config: 1,
  cost_center: [],
  seniority: 1,
  technology: [],
  job_role: [],
  end_date: "",
  isBilled: false,
  collaborator_cost: {
    total: "",
    cost_unity: "",
    cnpj: "",
    corporate_name: "",
  },
  bank_data: {
    bank: "",
    agency: "",
    account: "",
    person_entity: 0,
  },
  address: {
    street: "",
    number: "",
    complement: "",
    district: "",
    city: "",
    state: "",
    zip_code: "",
    country: "Brasil",
  },
  data_professional: {
    beginnig_at: "",
    hourly_pay: "",
    monthly_pay: "",
    type_tax_simple: true,
    type_tax_id: 0,
  },
};

export interface CheckBoxDTO {
  id: number | string;
  name: string;
  checked?: false;
  idField?: number;
}

export const FormContext = createContext({} as StoreContextProps);

export function FormStoreProvider({ children, params: urlId }: StoreProviderProps) {
  const { token, userId, accessIds } = useAppData();
  const [updateValue, setUpdateValues] = useState(initialValues as ValuesInterface);
  const [modo, setModo] = useState<"create" | "update">("create");
  const [state, setState] = useState(false);
  const [contract_type, setContract_Type] = useState(2);
  const [needSpinner, setNeedSpinner] = useState(true);
  const [listProfile, setListProfile] = useState([] as ProfileProps["profiles"]);
  const [selectedTech, setSelectedTech] = useState([] as CheckBoxDTO[]);
  const [selectedJob_roles, setSelectedJob_roles] = useState([] as CheckBoxDTO[]);
  const [selectedCostCenter, setSelectedCostCenter] = useState([] as CheckBoxDTO[]);
  const [resultCalcPreview, setResultCalcPreview] = useState({
    total: "",
    cost_unity: "",
  });
  const [modalStatus, setModalStatus] = useState(false);

  const [saveOrSchedule, setSaveOrSchedule] = useState<"save" | "schedule">("save");
  const [dateSchedule, setDateSchedule] = useState<string>();
  const [isScheduleId, setIsScheduleId] = useState(0);
  const [equipaments, setEquipaments] = useState<boolean>();
  const [tax, setTax] = useState([] as any[]);

  const params = isUrlSchedule(urlId);
  const history = useHistory();

  useEffect(() => {
    if (params != userId && !accessIds?.includes(ACCESS.USERS_DATA_all)) return history.push("/home");
    if (params) {
      getTax();
    } else {
      getProfiles();
    }
  }, []);

  async function getTax() {
    const res = await getTaxes(token);
    const taxAltered = taxDTO(res);
    setTax(taxAltered);
    if (urlId?.includes("schedule=")) {
      getUserScheduleById(taxAltered);
    } else {
      getCollaboratorData(taxAltered);
    }
  }

  function taxDTO(res: { name: string; id: number; simple: boolean }) {
    const data = orderByName(res, "name") ?? [];
    return data.map((item, index) => {
      return {
        ...item,
        id: index + 1,
        idField: item.id,
      };
    });
  }

  function isUrlSchedule(params) {
    if (params?.includes("schedule=")) return params?.replace("schedule=", "");
    return params;
  }

  async function getUserScheduleById(taxAltered) {
    const user = await serviceUsers.getUserScheduleById(token, params);
    if (user) {
      setDateSchedule(user.date);
      setValue(
        user.json,
        setState,
        setUpdateValues,
        setContract_Type,
        setSelectedTech,
        setSelectedJob_roles,
        setSelectedCostCenter,
        setResultCalcPreview,
        taxAltered,
      );
      setIsScheduleId(user.id);
      getProfiles("update");
      stopSpinner();
    } else {
      getCollaboratorData(taxAltered);
    }
  }

  async function getCollaboratorData(taxAltered) {
    await serviceUsers.getUsersById(token, params)?.then((data) => {
      setModo("update");
      setValue(
        data,
        setState,
        setUpdateValues,
        setContract_Type,
        setSelectedTech,
        setSelectedJob_roles,
        setSelectedCostCenter,
        setResultCalcPreview,
        taxAltered,
      );
      getProfiles("update");
      stopSpinner();
    });
    const user = await serviceUsers.getUserScheduleById(token, params);
    if (user) setIsScheduleId(user.id);
  }

  function stopSpinner() {
    setTimeout(() => {
      setNeedSpinner(false);
    }, 300);
  }

  async function getProfiles(modoScreen: "create" | "update" = modo) {
    let profiles = [];
    const profilesInBack: ProfileProps["profiles"] = await serviceUsers.getProfiles(token);
    if (profilesInBack?.length) {
      profiles = orderByName(profilesInBack, "name");
      setListProfile(profiles);
    }
    if (modoScreen === "create") {
      setUpdateValues({ ...updateValue, profile: profiles[2]?.id });
      setNeedSpinner(false);
    }
    return profiles;
  }

  function setUpdateValue(event: any) {
    const { name, value } = event;
    setUpdateValues({ ...updateValue, [`${name}`]: value });
  }

  function setUpdateValueObj(campo1: any, campo2: any) {
    const nameCamp = campo2.name;
    const value = campo2.value;
    const data = gerateDinamicObjectCollaborator(updateValue, campo1, nameCamp, value);
    setUpdateValues(data);
  }

  function setFormatedSelectedCostCenter(costCenter: CheckBoxDTO[]) {
    const costCenterClear = getReadyToSave(costCenter);
    setSelectedCostCenter(costCenterClear);
  }
  function setFormatedSelectedJob_roles(job_role: CheckBoxDTO[]) {
    const job_roleClear = getReadyToSave(job_role);
    setSelectedJob_roles(job_roleClear);
  }
  function setFormatedSelectedtech(tech: CheckBoxDTO[]) {
    const techClear = getReadyToSave(tech);
    setSelectedTech(techClear);
  }

  function getReadyToSave(list: any[]): CheckBoxDTO[] {
    return list
      .filter((item) => Boolean(item.checked))
      .map((item) => {
        return {
          id: item.idField,
          name: item.name,
        };
      });
  }

  function handleSetDate(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    const dateInput = Date.parse(value);
    const currentDay = Date.parse(currentDate());

    if (dateInput >= currentDay) {
      return setDateSchedule(value);
    }
    return toastError(`Data deve ser maior que: ${convertDate(currentDate())}`);
  }

  const importValueContext = {
    updateValue,
    setUpdateValue,
    modo,
    listProfile,
    setModo,
    state,
    setState,
    needSpinner,
    setNeedSpinner,
    setUpdateValueObj,
    contract_type,
    setContract_Type,
    selectedTech,
    setSelectedTech: setFormatedSelectedtech,
    selectedJob_roles,
    setSelectedJob_roles: setFormatedSelectedJob_roles,
    selectedCostCenter,
    setSelectedCostCenter: setFormatedSelectedCostCenter,
    setUpdateValues,
    resultCalcPreview,
    setResultCalcPreview,
    modalStatus,
    setModalStatus,
    params,
    saveOrSchedule,
    setSaveOrSchedule,
    dateSchedule,
    handleSetDate,
    isSchedule: isScheduleId,
    setIsSchedule: setIsScheduleId,
    equipaments,
    setEquipaments,
    tax,
    setTax,
  };

  return <FormContext.Provider value={importValueContext}>{children}</FormContext.Provider>;
}

const dataProfessionalValues = (values, tax: any[]) => {
  const taxThisUser = tax.find(
    (valueTax) => valueTax.idField === values.data_professional.type_tax_id && valueTax.simple === values.data_professional.type_tax_simple,
  );
  return {
    ...values.data_professional,
    type_tax_id: taxThisUser?.id,
    type_tax_simple: taxThisUser?.simple,
  };
};

function setValue(
  item: ValuesInterface,
  setState: any,
  setUpdateValues: any,
  setContract_Type: any,
  setSelectedTech: any,
  setSelectedJob_roles: any,
  setSelectedCostCenter: any,
  setResultCalcPreview: any,
  tax,
) {
  const value: ValuesInterface = {
    name: item?.name,
    email: item?.email,
    hourBase: item?.hourBase,
    email_personal: item?.email_personal,
    birth_date: item?.birth_date,
    isDeleted: item?.isDeleted,
    CPF: item?.CPF,
    RG: item?.RG,
    phone: item?.phone,
    phone_two: item?.phone_two,
    profile: item?.profile,
    pay_config: item?.pay_config === "HOURS" ? 2 : 1,
    cost_center: item?.cost_center ? item?.cost_center : [],
    technology: item?.technology ? item?.technology : [],
    seniority: item?.seniority ? item?.seniority : 1,
    job_role: item?.job_role ? item?.job_role : [],
    end_date: item?.end_date,
    isBilled: item?.isBilled,
    data_professional: item?.data_professional
      ? dataProfessionalValues(item, tax)
      : {
          beginnig_at: "",
          hourly_pay: "",
          monthly_pay: "",
          type_tax_simple: true,
          type_tax_id: 0,
        },
    collaborator_cost: item?.collaborator_cost
      ? item?.collaborator_cost
      : {
          total: "",
          cost_unity: "",
          cnpj: "",
          corporate_name: "",
        },
    bank_data: item?.bank_data
      ? {
          ...item?.bank_data,
          person_entity: PersonEntity[item?.bank_data?.person_entity],
        }
      : {
          bank: "",
          agency: "",
          account: "",
          person_entity: 0,
        },
    address: item?.address
      ? item?.address
      : {
          street: "",
          number: 0,
          complement: "",
          district: "",
          city: "",
          state: "",
          zip_code: "",
          country: "Brasil",
        },
  };

  setResultCalcPreview({
    total: item?.collaborator_cost?.total,
    cost_unity: item?.collaborator_cost?.cost_unity,
  });
  setSelectedTech(item?.technology);
  setSelectedJob_roles(item?.job_role);
  setSelectedCostCenter(item?.cost_center);
  setContract_Type(verifyContractType(item?.contract_type));
  setState(item?.isDeleted);
  setUpdateValues(value);
}

function verifyContractType(item) {
  if (item === "CLT") return 1;
  if (item === "PJ") return 2;
  return 0;
}
